export default __webpack_public_path__ + "static/media/404.7684d940.png";